import React from 'react';
import {Microlesson} from '../../../data/models/Microlessons/Microlesson';
import ImageWithFallback from '../../../uiToolkit/ImageWithFallback/ImageWithFallback';

interface Props {
  lesson: Microlesson;
  onSelectLesson: (lesson: Microlesson) => void;
  selected: boolean;
}

const MicrolessonsLibraryCard = React.memo(
  ({lesson, onSelectLesson, selected}: Props) => {
    return (
      <div
        className="MicrolessonLibraryCard"
        onClick={() => onSelectLesson(lesson)}>
        <div className="Poster">
          <ImageWithFallback src={lesson.poster} />
        </div>
        <div className="InfoContainer">
          <p>{lesson.title}</p>
        </div>
        {selected && (
          <div className="SelectedMicrolessonOverlay">
            <div className="CheckContainer">
              <span className="icon-check"></span>
            </div>
          </div>
        )}
      </div>
    );
  },
);

export default MicrolessonsLibraryCard;
